
import React from 'react'
import { HomeWrapper, SideWrapper, MainHeading, FooterLinks } from './HomeStyles'
import { StyledLink } from '../Header/HeaderStyles'


const Home = ({ links, setShowNav,  }) => {
    
    return (
      <HomeWrapper>
        <div className="first-half">
          <MainHeading>
            <span>Hair</span> <span> definition</span>
          </MainHeading>
          <footer>
            <FooterLinks>
              {links.map((link) => {
                return (
                  <li key={link.id}>
                    <StyledLink
                      onClick={() => {
                        setShowNav((showNav) => {
                          return !showNav;
                        });
                      }}
                      to={link.linkPath}
                    >
                      {link.linkName}
                    </StyledLink>
                  </li>
                );
              })}
            </FooterLinks>
          </footer>
        </div>

        <SideWrapper></SideWrapper>
      </HomeWrapper>
    );
}

export default Home
